import { Dimensions } from "Types/Sizing";

export const DefaultIconSize: Dimensions = {
    width: 24,
    height: 24
};
